import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import IconButton from '@material-ui/core/IconButton'
import BuildIcon from '@material-ui/icons/Build'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import DebugItems from './DebugItems'
import DebugDrawerHeader from './DebugDrawerHeader'
import DebugDrawerCloseButton from './DebugDrawerCloseButton'
import DebugActions from '../redux/debugRedux'

const styles = {
  list: {
    width: 250,
    flex: 'initial'
  },
  listFull: {
    width: 'auto',
    flex: 'initial'
  }
}

class DebugDrawer extends React.Component {
  render () {
    const { actions, classes, debugDrawerOpen } = this.props

    return (
      <div>
        <IconButton
          color='inherit'
          aria-label='Debug'
          onClick={actions.debugDrawerOpened}
        >
          <BuildIcon />
        </IconButton>
        <Drawer
          anchor='right'
          type='persistent'
          open={debugDrawerOpen}
          onClose={actions.debugDrawerClosed}
        >
          <div>
            <DebugDrawerHeader>
              <DebugDrawerCloseButton handleClose={actions.debugDrawerClosed} />
            </DebugDrawerHeader>
            <Divider />
            <List className={classes.list}>
              <DebugItems />
            </List>
          </div>
        </Drawer>
      </div>
    )
  }
}

DebugDrawer.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => {
  return {
    debugDrawerOpen: state.debug.debugDrawerOpen
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      debugDrawerOpened: () => dispatch(DebugActions.debugDrawerOpened()),
      debugDrawerClosed: () => dispatch(DebugActions.debugDrawerClosed())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(DebugDrawer)
)



// WEBPACK FOOTER //
// ./src/debug/DebugDrawer.js